import React from 'react';
import { DatePicker, Space } from 'antd';
import moment from 'moment/moment.js';
import { Spinner } from 'react-bootstrap';
import TableComponent from '../../../../../_metronic/table/TableComponent';
import { useState, useEffect } from 'react';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

const dateFormat = 'YYYY-MM-DD';

const headers = [
  { label: 'Store Name', key: 'store_name' },
  { label: 'Area name', key: 'area_name' },
  { label: 'Total Discount', key: 'totalDiscount' },
  { label: 'Total kg', key: 'totalKg' },
  { label: 'Total Orders', key: 'totalOrders' },
  { label: 'Total purchased value', key: 'totalValuePurchased' },
  { label: 'Volume Quantity', key: 'volumeQty' },
];

export default function AreawiseInvoice() {
  // Token From State
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);
  // Token From State

  const [loading, setLoading] = useState(false);
  const [areawiseInvoice, setAreawiseInvoice] = useState([]);
  const [areawiseInvoiceTable, setAreawiseInvoiceTable] = useState(false);

  const [date_from, setDate_from] = useState(
    moment()
      .startOf('month')
      .format(dateFormat)
  );
  const [date_to, setDate_to] = useState(
    moment()
      .endOf('month')
      .format(dateFormat)
  );

  useEffect(() => {
    handleSearch();
  }, []);

  // 1- Get Areawise Invoice data by search
  const handleSearch = async () => {
    let searchData = {
      type: 'B2C',
      start_date: moment(date_from).format(dateFormat),
      end_date: moment(date_to).format(dateFormat),
    };

    setLoading(true);
    const { data, status } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/areaWsieInvoice`,
      searchData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (status === 404 || status === 204 || data.data.length === 0) {
      setLoading(false);
      swal({
        title: 'No data Found',
        icon: 'info',
      });
    } else if (!data.error) {
      setLoading(false);
      if (data.data.length) {
        setAreawiseInvoice(data.data);
        setAreawiseInvoiceTable(true);
      } else {
        setAreawiseInvoice([]);
      }
    } else {
      swal({
        title: data.message,
        icon: 'info',
      });
    }
  };
  // 1- Get Areawise Invoice data by search

  // React Table
  const data = React.useMemo(() => areawiseInvoice, [areawiseInvoice]);

  const columns = React.useMemo(() => [
    {
      Header: '#',
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: 'Store name',
      accessor: 'store_name',
      paddingLeft: '0px',
    },
    {
      Header: 'Area name',
      accessor: 'area_name',
      paddingLeft: '0px',
    },

    {
      Header: 'Total discount',
      accessor: 'totalDiscount',
      paddingLeft: '0px',
    },

    {
      Header: 'Total kg',
      accessor: 'totalKg',
      paddingLeft: '0px',
    },
    {
      Header: 'Total orders',
      accessor: 'totalOrders',
      paddingLeft: '0px',
    },
    {
      Header: 'Total purchased value',
      accessor: 'totalValuePurchased',
      width: 240,
      paddingLeft: '0px',
    },
    {
      Header: 'Volume qty',
      accessor: 'volumeQty',
      paddingLeft: '0px',
    },
  ]);

  // Content
  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Area-wise Invoice</h3>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                Start Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_from)}
                  onChange={(date, dateString) => setDate_from(dateString)}
                />
              </Space>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                End Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_to)}
                  onChange={(date, dateString) => setDate_to(dateString)}
                />
              </Space>
            </div>
          </div>

          <div className="col-md-2 text-right mt-10">
            <button
              className="btn btn-primary w-75"
              onClick={handleSearch}
              // onClick={() => handleSearch()}
              disabled={loading}
            >
              Search{' '}
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {areawiseInvoiceTable && (
        <TableComponent
          columns={columns}
          data={data}
          hideAddButton={true}
          lists={areawiseInvoice}
          csv={true}
          excelHeader={headers}
          filename={'Area-wise Invoice.csv'}
        />
      )}
    </div>
  );
}
